import { render, staticRenderFns } from "./ModalCadastroMedicoSecretaria.vue?vue&type=template&id=ba659008&scoped=true"
import script from "./ModalCadastroMedicoSecretaria.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroMedicoSecretaria.vue?vue&type=script&lang=ts"
import style0 from "./ModalCadastroMedicoSecretaria.vue?vue&type=style&index=0&id=ba659008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba659008",
  null
  
)

export default component.exports